import select from './RoleSelect.vue'
const FormRoleSelect = {
  install: function (Vue) {
    Vue.component('FormRoleSelect', select)
  }
}
export default FormRoleSelect
